import React from "react";
import { benefits } from "../mock";

export default function Benefits() {
  return (
    <section data-testid="key-benefits-section" aria-label="Key benefits" className="home-section home-section--band" style={{ background: "var(--cream-2)" }}>
      <div className="container">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <div key={b.title} className="reveal group rounded-2xl border p-6 transition-transform hover:-translate-y-1"
                   style={{ transitionDelay: `${i * 60}ms`, borderColor: "rgba(45,106,79,0.16)",
                            background: "linear-gradient(135deg, rgba(255,248,236,0.94), rgba(255,255,255,0.88))",
                            boxShadow: "0 12px 30px rgba(45,106,79,0.08)" }}>
                <span className="grid h-12 w-12 place-items-center rounded-xl transition-colors"
                      style={{ background: "rgba(232,80,26,0.10)", color: "#E8501A" }}>
                  <Icon size={24} />
                </span>
                <strong className="mt-4 block font-heading text-[19px] font-extrabold" style={{ color: "var(--green-950)" }}>
                  {b.title}
                </strong>
                <span className="mt-1 block text-[14.5px] font-medium" style={{ color: "#3a5347" }}>{b.desc}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
